import { NgTemplateOutlet } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { Warehouse } from "../../../../_models";
import { FullProjectTechnician } from "../../../../_models/project-technician.interface";
import { FullProjectHash } from "../../../../_models/project.interface";
import { UserService } from "../../../../_services";
import { FormModalComponent } from "../form-modal-component.class";

@Component({
  selector: "hawk-edit-project-technician-modal",
  imports: [ReactiveFormsModule, NgTemplateOutlet],
  templateUrl: "./edit-project-technician-modal.component.html",
  standalone: true,
  styleUrls: ["edit-project-technician-modal.component.scss"],
})
export class EditProjectTechnicianModalComponent
  extends FormModalComponent<FullProjectTechnician, FullProjectHash>
  implements OnChanges
{
  @Input() userID: number | string;
  @Input() override formGroup: UntypedFormGroup;
  @Output() override closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() override newDBOutput: EventEmitter<FullProjectHash> = new EventEmitter<FullProjectHash>();

  warehouses: Warehouse[] = [];

  constructor(private userService: UserService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.userID) {
      this.userService.getUsersWarehouses(changes.userID.currentValue).subscribe(
        (data) => (this.warehouses = data),
        (err) => console.log(err),
      );
    }
  }

  override formGroupToDBInput(): FullProjectTechnician {
    throw new Error("Method not implemented.");
  }

  override getDBCallObservable(object: FullProjectTechnician): Observable<FullProjectHash> {
    throw new Error("Method not implemented.");
  }
}
